const compareData = [
    {
        "country": "Switzerland*",
        "project": 100,
        "career": 81,
        "employ": 85,
        "iso_code": "CHE",
        "ISO2": "CH"
    },
    {
        "country": "Singapore*",
        "project": 100,
        "career": 61,
        "employ": 99,
        "iso_code": "SGP",
        "ISO2": "SG"
    },
    {
        "country": "Saudi Arabia",
        "project": 100,
        "career": 46,
        "employ": 63,
        "iso_code": "SAU",
        "ISO2": "SA"
    },
    {
        "country": "United States of America*",
        "project": 89,
        "career": 75,
        "employ": 85,
        "iso_code": "USA",
        "ISO2": "US"
    },
    {
        "country": "Hong Kong*",
        "project": 85,
        "career": 52,
        "employ": 81,
        "iso_code": "HKG",
        "ISO2": "HK"
    },
    {
        "country": "United Arab Emirates*",
        "project": 78,
        "career": 51,
        "employ": 84,
        "iso_code": "ARE",
        "ISO2": "AE"
    },
    {
        "country": "Panama*",
        "project": 74,
        "career": 28,
        "employ": 31,
        "iso_code": "PAN",
        "ISO2": "PA"
    },
    {
        "country": "Latvia*",
        "project": 73,
        "career": 59,
        "employ": 48,
        "iso_code": "LVA",
        "ISO2": "LV"
    },
    {
        "country": "Hungary*",
        "project": 71,
        "career": 43,
        "employ": 49,
        "iso_code": "HUN",
        "ISO2": "HU"
    },
    {
        "country": "Australia*",
        "project": 69,
        "career": 66,
        "employ": 77,
        "iso_code": "AUS",
        "ISO2": "AU"
    },
    {
        "country": "Canada*",
        "project": 66,
        "career": 74,
        "employ": 80,
        "iso_code": "CAN",
        "ISO2": "CA"
    },
    {
        "country": "Brazil",
        "project": 63,
        "career": 59,
        "employ": 33,
        "iso_code": "BRA",
        "ISO2": "BR"
    },
    {
        "country": "United Kingdom*",
        "project": 62,
        "career": 58,
        "employ": 71,
        "iso_code": "GBR",
        "ISO2": "GB"
    },
    {
        "country": "New Zealand*",
        "project": 61,
        "career": 54,
        "employ": 60,
        "iso_code": "NZL",
        "ISO2": "NZ"
    },
    {
        "country": "Mexico",
        "project": 61,
        "career": 47,
        "employ": 36,
        "iso_code": "MEX",
        "ISO2": "MX"
    },
    {
        "country": "Austria*",
        "project": 58,
        "career": 56,
        "employ": 69,
        "iso_code": "AUT",
        "ISO2": "AT"
    },
    {
        "country": "Italy*",
        "project": 53,
        "career": 61,
        "employ": 65,
        "iso_code": "ITA",
        "ISO2": "IT"
    },
    {
        "country": "Colombia",
        "project": 53,
        "career": 41,
        "employ": 29,
        "iso_code": "COL",
        "ISO2": "CO"
    },
    {
        "country": "Peru",
        "project": 52,
        "career": 39,
        "employ": 27,
        "iso_code": "PER",
        "ISO2": "PE"
    },
    {
        "country": "Greece*",
        "project": 48,
        "career": 44,
        "employ": 59,
        "iso_code": "GRC",
        "ISO2": "GR"
    },
    {
        "country": "Ecuador",
        "project": 48,
        "career": 27,
        "employ": 16,
        "iso_code": "ECU",
        "ISO2": "EC"
    },
    {
        "country": "Malta*",
        "project": 44,
        "career": 62,
        "employ": 58,
        "iso_code": "MLT",
        "ISO2": "MT"
    },
    {
        "country": "China",
        "project": 44,
        "career": 67,
        "employ": 45,
        "iso_code": "CHN",
        "ISO2": "CN"
    },
    {
        "country": "Bolivia",
        "project": 42,
        "career": 30,
        "employ": 16,
        "iso_code": "BOL",
        "ISO2": "BO"
    },
    {
        "country": "Portugal*",
        "project": 41,
        "career": 50,
        "employ": 52,
        "iso_code": "PRT",
        "ISO2": "PT"
    },
    {
        "country": "Thailand*",
        "project": 41,
        "career": 44,
        "employ": 52,
        "iso_code": "THA",
        "ISO2": "TH"
    },
    {
        "country": "South Africa",
        "project": 41,
        "career": 39,
        "employ": 46,
        "iso_code": "ZAF",
        "ISO2": "ZA"
    },
    {
        "country": "Cameroon",
        "project": 37,
        "career": 16,
        "employ": 20,
        "iso_code": "CMR",
        "ISO2": "CM"
    },
    {
        "country": "Russia",
        "project": 36,
        "career": 40,
        "employ": 29,
        "iso_code": "RUS",
        "ISO2": "RU"
    },
    {
        "country": "Taiwan",
        "project": 34,
        "career": 46,
        "employ": 57,
        "iso_code": "TWN",
        "ISO2": "TW"
    },
    {
        "country": "Philippines",
        "project": 34,
        "career": 35,
        "employ": 34,
        "iso_code": "PHL",
        "ISO2": "PH"
    },
    {
        "country": "Ukraine",
        "project": 31,
        "career": 26,
        "employ": 23,
        "iso_code": "UKR",
        "ISO2": "UA"
    },
    {
        "country": "Vietnam",
        "project": 31,
        "career": 40,
        "employ": 23,
        "iso_code": "VNM",
        "ISO2": "VN"
    },
    {
        "country": "Türkiye*",
        "project": 29,
        "career": 40,
        "employ": 46,
        "iso_code": "TUR",
        "ISO2": "TR"
    },
    {
        "country": "India",
        "project": 29,
        "career": 57,
        "employ": 41,
        "iso_code": "IND",
        "ISO2": "IN"
    },
    {
        "country": "Malaysia*",
        "project": 28,
        "career": 45,
        "employ": 55,
        "iso_code": "MYS",
        "ISO2": "MY"
    },
    {
        "country": "Kazakhstan",
        "project": 28,
        "career": 30,
        "employ": 33,
        "iso_code": "KAZ",
        "ISO2": "KZ"
    },
    {
        "country": "Mauritius*",
        "project": 27,
        "career": 30,
        "employ": 22,
        "iso_code": "MUS",
        "ISO2": "MU"
    },
    {
        "country": "Morocco",
        "project": 26,
        "career": 25,
        "employ": 21,
        "iso_code": "MAR",
        "ISO2": "MA"
    },
    {
        "country": "Kenya",
        "project": 26,
        "career": 25,
        "employ": 25,
        "iso_code": "KEN",
        "ISO2": "KE"
    },
    {
        "country": "Indonesia",
        "project": 25,
        "career": 44,
        "employ": 38,
        "iso_code": "IDN",
        "ISO2": "ID"
    },
    {
        "country": "Egypt*",
        "project": 25,
        "career": 33,
        "employ": 20,
        "iso_code": "EGY",
        "ISO2": "EG"
    },
    {
        "country": "Nigeria",
        "project": 25,
        "career": 37,
        "employ": 20,
        "iso_code": "NGA",
        "ISO2": "NG"
    },
    {
        "country": "Ghana",
        "project": 23,
        "career": 33,
        "employ": 23,
        "iso_code": "GHA",
        "ISO2": "GH"
    },
    {
        "country": "Pakistan",
        "project": 23,
        "career": 31,
        "employ": 14,
        "iso_code": "PAK",
        "ISO2": "PK"
    },
    {
        "country": "Ethiopia",
        "project": 23,
        "career": 31,
        "employ": 19,
        "iso_code": "ETH",
        "ISO2": "ET"
    }
];


export {compareData};